import { useQuery } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * Fetches the org's current rulebook ingestion run status (WOR-52). Used to put
 * the regulatory feed catalog into a read-only state while a run is in flight.
 * tRPC-only — the status is projected onto ingestion_config by a backend event
 * consumer and has no GraphQL equivalent, so this is a thin direct `useQuery`
 * wrapper rather than a `createQueryHook` bridge.
 */
export const useGetIngestionRunStatus = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const trpc = useTRPC();

  return useQuery({
    ...trpc.frontend.ingestionConfig.getActiveRun.queryOptions(),
    enabled,
  });
};
